module.exports = global["jQuery"] = require("-!D:\\TPI01FIA\\TOYOTA\\toyota-merge\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");